export default class Store {
    constructor() {
        this.lexical = {}
    }
    setLexicalValue = (key, value) => this.lexical[key] = value
    getLexicalValueByKey = key => this.lexical[key];
    lexicalKeyExist = key => (typeof this.lexical[key] !== "undefined")
    getLexical = () => this.lexical
}